/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';

import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class DesktopProjectService {
	public updateProjectProperty(projectId: string, property: { [key: string]: any }): void {
		const path = fancyFirebaseGetters.getProjectsPath(projectId);
		const ref = fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(path, projectId);
		ref.update(property);
	}

	constructor() {}
}
